import React, { useContext, useEffect } from "react";
import { OrgContext } from "contexts/OrgContext";
import { useHistory } from "react-router-dom";
import EnvironmentListRedesign from "./Redesign/index";

export const EnvironmentListRedirect: React.FC = () => {
  const router = useHistory();
  const orgContext = useContext(OrgContext);

  useEffect(() => {
    router.push(`/org/${orgContext.activeOrgId}/environments`);
  }, [orgContext.activeOrgId, router]);

  return <></>;
};

const EnvironmentList: React.FC = () => <EnvironmentListRedesign />;

export default EnvironmentList;
